module.exports = __webpack_public_path__ + "static/img/p-s4-4.306759f1.png";